import React from 'react';
import Card from '../../components/Card/Card';
import GqlQueryWrapper from '../../components/GqlQueryWrapper/GqlQueryWrapper';
import Table from '../../components/Table/Table';
import TablePreRender from '../../components/Table/Table.prerender';
import ErrorMessageNewFund from '../../components/ErrorMessages/ErrorMessageNewFund';

import {
    THIRTY_DAY,
    FI_ETF_THIRTY_DAY
    // THIRTY_DAY_PRTIX
} from './queries';
import {
    yieldPerformanceUtil,
    // theCompareTickerFunc,
    defaultDisclosure
} from './util';
import { CARD_NAMES } from '../../utils/constants';
import { setCardID } from '../../utils/Format/Format';

import styles from './YieldPerformance.css';

// const getQuery = (moneyMarket, isFI) => {
//     if (moneyMarket) {
//         return SEVEN_DAY;
//     }
//     if (isFI) {
//         return FI_ETF_THIRTY_DAY;
//     }
//     return THIRTY_DAY;
// };

// const theCompareTicker = 'PRTIX';

const YieldPerformance = ({ ticker, /* moneyMarket, */ isFI }) => (
    <Card className="left" id={setCardID(CARD_NAMES.YIELD_PERFORMANCE)}>
        <div className="subsection-no-border" />
        <div>
            {/* <GqlQueryWrapper
                query={THIRTY_DAY_PRTIX}
                variables={{ theCompareTicker }}
                placeholder={() => <TablePreRender />}
            >
                {({ data }) => (
                    <React.Fragment>
                        {theCompareTickerFunc(
                            (data.mutualFund || {}).yield30DayStandard,
                            (data.mutualFund || {})
                                .unsubsidizedThirtyDaySECYield
                        )}
                    </React.Fragment>
                )}
            </GqlQueryWrapper> */}
            <GqlQueryWrapper
                query={isFI ? FI_ETF_THIRTY_DAY : THIRTY_DAY}
                variables={{ ticker }}
                dataFunc={yieldPerformanceUtil(/* moneyMarket, */ ticker, isFI)}
                placeholder={() => <TablePreRender />}
            >
                {({ data: { data, headers, quarterlyDate } }) =>
                    !quarterlyDate ? (
                        <ErrorMessageNewFund
                            cardName={CARD_NAMES.YIELD_PERFORMANCE}
                        />
                    ) : (
                        <React.Fragment>
                            <div
                                id="day-yield-table"
                                className="table-container"
                            >
                                <Table
                                    data={{ data, headers }}
                                    displayTooltip
                                />
                            </div>
                            {/* {moneyMarket && ( */}
                            {/*    <div className="day-yield-footer-text"> */}
                            {/*        <div> */}
                            {/*            A method of calculating a money fund’s */}
                            {/*            yield by annualizing the fund’s net */}
                            {/*            investment income for the last seven */}
                            {/*            days of each period divided by the */}
                            {/*            fund’s net asset value at the end of the */}
                            {/*            period. */}
                            {/*        </div> */}
                            {/*    </div> */}
                            {/* )} */}
                            {/* {!moneyMarket && ( */}
                            <div className="day-yield-footer-text">
                                {!isFI &&
                                    `The 30-day dividend yield represents the
                                    average daily dividends for the 30-day
                                    period, annualized and divided by the net
                                    asset values per share at the end of the
                                    period; it is available the first quarter
                                    after the fund's inception. `}The SEC
                                standardized yield is computed under an SEC
                                standardized formula and reflects an estimated
                                yield to maturity (assuming all portfolio
                                securities are held to maturity); it is
                                available the first month after the fund&rsquo;s
                                inception.
                            </div>
                            {/* )} */}

                            <div className="day-yield-footer-text">
                                SEC Yield w/o Waiver excludes the effect of
                                contractual expense limitation arrangements.
                            </div>
                            {defaultDisclosure(ticker) && (
                                <div className="day-yield-footer-text">
                                    <sup>§</sup> The fund’s 30-day SEC
                                    standardized yield can be volatile due to
                                    changes in the inflation rate and the
                                    treatment of inflation adjustments on TIPS
                                    holdings as income in that yield
                                    calculation. Inflation adjustments are
                                    accrued daily but are typically distributed
                                    annually rather than paid monthly with
                                    ordinary coupon income. The fund’s 30-day
                                    annualized dividend yield does not include
                                    these accrued inflation adjustments until
                                    they are paid and normally reflects the
                                    actual dividends paid to shareholders.
                                    Changes in inflation rates and real interest
                                    rates, as well as the effect of inflation
                                    adjustments, may cause the fund’s yield to
                                    vary substantially from one month to the
                                    next and might not be repeated.
                                </div>
                            )}
                        </React.Fragment>
                    )
                }
            </GqlQueryWrapper>
        </div>

        <style jsx>{styles}</style>
    </Card>
);

export default YieldPerformance;
